package fr.frux.shared.data.repository

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.logging.Logger
import fr.frux.core.common.platform.platformId
import fr.frux.core.common.result.runCatchingCancellable
import fr.frux.core.network.api.SupportApi
import fr.frux.core.network.error.mapFailureToAppError
import fr.frux.shared.domain.model.SupportPrompt
import fr.frux.shared.domain.model.SupportReason
import fr.frux.shared.domain.model.SupportVariant
import fr.frux.shared.domain.repository.SupportRepository
import fr.frux.shared.dto.SupportPromptReason
import fr.frux.shared.dto.SupportPromptVariant

/**
 * Implementation of SupportRepository, à l'identique de NotificationRepositoryImpl.
 */
@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class SupportRepositoryImpl(
    private val api: SupportApi,
    private val platform: String = platformId,
) : SupportRepository {
    companion object {
        private const val TAG = "SupportRepository"
    }

    override suspend fun prompt(): Result<SupportPrompt?> =
        runCatchingCancellable {
            val response = api.getPrompt(platform)
            val url = response.donateUrl
            if (!response.show || url == null) {
                null
            } else {
                SupportPrompt(
                    reason =
                        when (response.reason) {
                            SupportPromptReason.HARVEST -> SupportReason.HARVEST
                            else -> SupportReason.CONTRIBUTION
                        },
                    variant =
                        when (response.variant) {
                            SupportPromptVariant.INLINE -> SupportVariant.INLINE
                            SupportPromptVariant.LINK_OUT -> SupportVariant.LINK_OUT
                        },
                    donateUrl = url,
                )
            }
        }.onFailure { Logger.e(TAG, "❌ Chargement de la sollicitation échoué", it) }
            .mapFailureToAppError()

    override suspend fun markShown(): Result<Unit> =
        runCatchingCancellable { api.markPromptShown() }
            .onFailure { Logger.e(TAG, "❌ Marquage affiché de la sollicitation échoué", it) }
            .mapFailureToAppError()

    override suspend fun optOut(): Result<Unit> =
        runCatchingCancellable { api.optOut() }
            .onFailure { Logger.e(TAG, "❌ Refus de la sollicitation échoué", it) }
            .mapFailureToAppError()

    override suspend fun donateUrl(): Result<String> =
        runCatchingCancellable { api.getDonateUrl().donateUrl }
            .onFailure { Logger.e(TAG, "❌ Récupération de l'URL de don échouée", it) }
            .mapFailureToAppError()
}
